import React from "react";
import "./compactPage.scss";

export function CompactIcon({ name }: { name: "refresh" | "search" | "plus" | "filter" | "file" | "external" | "edit" | "chevron" | "close" | "box" }) {
    const paths = {
        refresh: <><path d="M20 7v5h-5M4 17v-5h5" /><path d="M6 7a7 7 0 0 1 12-1l2 3M4 15l2 3a7 7 0 0 0 12-1" /></>,
        search: <><circle cx="10.5" cy="10.5" r="6.5" /><path d="m16 16 5 5" /></>,
        plus: <path d="M12 5v14M5 12h14" />,
        filter: <><path d="M4 6h16M4 12h16M4 18h16" /><circle cx="8" cy="6" r="2" fill="currentColor" /><circle cx="16" cy="12" r="2" fill="currentColor" /><circle cx="10" cy="18" r="2" fill="currentColor" /></>,
        file: <><path d="M14 3H5v18h14V8l-5-5ZM14 3v5h5M8 12h8M8 16h6" /></>,
        external: <path d="M14 3h7v7M21 3 10 14M10 5H4v15h15v-6" />,
        edit: <path d="m15 5 4 4M4 20l4-1L20 7a2.8 2.8 0 0 0-4-4L4 15Z" />,
        chevron: <path d="m7 9 5 5 5-5" />,
        close: <path d="m6 6 12 12M6 18 18 6" />,
        box: <><path d="m3 7 9-4 9 4-9 4-9-4Zm0 0v10l9 4 9-4V7M12 11v10" /><path d="m7.5 5 9 4" /></>,
    };
    return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name]}</svg>;
}
export function CompactSearch({ value, onChange, label, placeholder }: { value: string; onChange: (value: string) => void; label: string; placeholder: string }) {
    return <div className="compact-search"><CompactIcon name="search" /><input type="search" aria-label={label} placeholder={placeholder} value={value} onChange={event => onChange(event.target.value)} />
        {value && <button type="button" className="compact-icon-button" aria-label="Очистить поиск" onClick={() => onChange("")}><CompactIcon name="close" /></button>}</div>;
}

